import { render } from "./wokerDetail4.vue?vue&type=template&id=6b8274c8&scoped=true"
import script from "./wokerDetail4.vue?vue&type=script&lang=js"
export * from "./wokerDetail4.vue?vue&type=script&lang=js"

import "./wokerDetail4.vue?vue&type=style&index=0&id=6b8274c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8274c8"]])

export default __exports__